<template>
  <v-container fluid class="pa-0">

    <v-row justify="center">

      <v-dialog v-model="dialogFamiliar" width="430px">
        <v-card>
          <v-card-text>
            <div class="text-center">

              <br>
              <br>
              <label style="font-family: Poppins; font-style: normal; font-weight: 400; font-size: 18px; line-height: 140%; letter-spacing: 0.02em;
                      color: black; flex: none; order: 1; flex-grow: 0;">Estas son las coberturas
                del </label>
              <label style="font-family: Poppins; font-style: normal; font-weight: 400; font-size: 18px; line-height: 140%; letter-spacing: 0.02em;
                      color: black; flex: none; order: 1; flex-grow: 0;">Plan<label
                  style="font-family: Poppins; font-style: normal; font-weight: 600; 
                      font-size: 20px; line-height: 140%; letter-spacing: 0.02em; color: #2D387C; flex: none; order: 1; flex-grow: 0; text-transform: uppercase;">
                  {{ info[0][indexInfo] }}</label> Seguro Oncológico de Southbridge.
              </label>

              <br>
              <br>
              <label class="text-center encabezado">{{ info[1][indexInfo] }} Reembolso Gastos médicos tratamiento
                Oncológico familiar.</label>
              <br>
              <br>
              <label class="texto">En caso de que te diagnostiquen a ti o algún integrante de tu familia que esté
                contigo
                en el seguro algún tipo de cáncer,
                podrán iniciar el tratamiento en Centro Médico donde <label class="textoAzul">reembolsaremos
                  el {{ info[1][indexInfo] }} de los gastos</label> del tratamiento por hasta <label
                  class="textoAzul">UF
                  {{ info[2][indexInfo] }} por cada asegurado </label>(más de 1.000 millones de pesos).
                <br>Si quieres revisar más en detalle los gastos que cubre haz clic <a :href="document"
                  target="_blank">aquí</a> </label>
              <br>
              <br>
              <label class="text-center encabezado">Indemnización {{ info[3][indexInfo] }} UF Libre disposición ante
                diagnóstico positivo.</label>
              <br>
              <br>
              <label class="texto">En caso de que te diagnostiquen a ti o algún integrante de tu familia que esté
                contigo
                en el seguro algún tipo de cáncer, podrás solicitar a la compañía
                <label class="textoAzul">{{ info[1][indexInfo] }}</label> de indemnización para que lo usen en lo que
                quieran, como alojamientos y traslados para tu tratamiento o comprarse lo que necesiten.
                <label class="textoAzul">
                  Sin preguntas</label>.</label>
              <br>
              <br>
              <label class="texto">Esto pueden solicitarlo con la confirmación de <label class="textoAzul">UC
                  CHRISTUS</label> de
                contratación y hasta de un diagnóstico positivo de cáncer.</label>
              <br>
              <br>
              <label class="text-center encabezado">Agrega a integrantes de tu familia sin cambiar el precio del
                seguro.</label>
              <br>
              <br>
              <label class="texto">El plan {{ info[0][indexInfo] }} permite que agregues a tu <label
                  class="textoAzul">cónyuge/pareja/conviviente </label>
                y a <label class="textoAzul">todos </label>tus y sus <label class="textoAzul">hijos e hijas
                </label>(hasta
                24 años de edad) por el <label class="textoAzul">mismo valor del plan</label>, y cada uno con la
                protección de UF 30.000 de tratamiento y con las UF {{ info[5][indexInfo] }} de indemnización ante
                diagnostico positivo. </label>
              <br>
              <br>
              <label class="text-center encabezado">Protección desde el día que contratas</label>
              <br>
              <br>
              <label class="texto">La protección de este seguro comienza desde el <label class="textoAzul">día que
                  contratas</label>.
                Olvídate de carencias o semanas para que comience a protegerte. </label>
              <br>

            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn style="box-sizing: border-box; padding: 12px 24px; gap: 10px; background: #4F74E3; border: 2px solid #4F74E3;
                    border-radius: 8px; margin-top: -6%; font-family: Poppins; font-style: normal; font-weight: 700; font-size: 14px; line-height: 17px;
                    letter-spacing: 0.02em; color: white; flex: none; order: 0; flex-grow: 0; margin:auto;"
              elevation="0" text @click="dialogFamiliar = false">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-row>

    <br>

    <Titulo></Titulo>

    <br v-if="screen < 800">

    <v-stepper v-model="e1" elevation="0" :class="Vstep">
      <div :class="Vflex">
        <NavBar :step="2"></NavBar>
        <v-stepper-header>
          <div class="circle-step">
            <v-stepper-step class="stepForms" style="flex-direction: column;" :color="stepperColor" :complete="e1 > 1"
              step="1">
              Inicio
            </v-stepper-step>
          </div>
          <v-divider></v-divider>
          <div class="circle-step">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 2" step="2"> Plan
            </v-stepper-step>
          </div>
          <v-divider></v-divider>
          <div class="circle-step2">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 4" step="4"> DPS
            </v-stepper-step>
          </div>
          <v-divider></v-divider>
          <div class="circle-step2">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" step="5"> Datos </v-stepper-step>
          </div>
        </v-stepper-header>
      </div>

      <br>

      <v-stepper-items>
        <v-stepper-content step="2">
          <div>

            <v-form ref="form" v-model="valid">

              <div class="formData">

                <br>
                <br>

                <h3 class="text-center labelPlanes">
                  Ingresa los datos de tu familia
                </h3>
                <br>
                <h4 v-if="screen > 800" class="text-center labelSubPlanes">
                  Como elegiste un plan familiar, debes agregar la información personal de tu grupo <br> familiar. Es
                  importante completarlo correctamente para no afectar la cobertura.
                </h4>

                <h4 v-else class="text-center labelSubPlanes2">
                  Como elegiste un plan familiar, debes agregar la información personal de tu grupo <br> familiar. Es
                  importante completarlo correctamente para no afectar la cobertura.
                </h4>

                <br>
                <br>

                <template>

                  <v-card>
                    <v-tabs v-model="activeTab" background-color="rgba(79, 116, 227, 1)" centered grow>
                      <v-tab class="headerSlider" v-for="(benef, i) in benefData" :key="'tab-' + i"
                        :href="'#benef-' + i">
                        {{ benef.name }} {{ benef.surname }}
                      </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="activeTab">
                      <v-tab-item v-for="(benef, i) in benefData" :key="'item-' + i" :value="'benef-' + i">
                        <v-card flat>
                          <v-card-text style="width: 60%; margin-left: 20%;">
                            <v-col>

                              <v-select :items="personType" v-model="benef.tipo" label="Parentesco"
                                :rules="parentescoRules" return-object required filled solo>
                              </v-select>

                              <h4 class=" labelEtiqueta">
                                Nombre
                              </h4>
                              <v-text-field v-model="benef.name" :rules="nameRules" label="Nombre" maxlength="51"
                                style="margin: auto;" required filled solo>
                              </v-text-field>

                              <h4 class="labelEtiqueta">
                                Apellido
                              </h4>
                              <v-text-field class="labelsEntrada" v-model="benef.surname" :rules="surnameRules"
                                maxlength="51" label="Apellido" required filled solo style="margin: auto;">
                              </v-text-field>

                              <h4 class="labelEtiqueta">
                                RUT
                              </h4>
                              <v-text-field class="labelsEntrada" v-model.lazy="benef.newRut" :rules="rutRules" label=""
                                required filled solo style="margin: auto;" @input="changeRut(i)">
                              </v-text-field>

                              <v-row>
                                <v-col>
                                  <v-select class="labelDate" :items="benef.months" v-model="benef.month"
                                    :rules="monthRules" :loading="loadingMonths" v-on:change="getDays(i)"
                                    item-text="name" label="Mes" return-object required filled solo>
                                  </v-select>
                                </v-col>
                                <br v-if="screen < 800">
                                <v-col>
                                  <v-select class="labelDate" :items="benef.days" v-model="benef.day" :rules="dayRules"
                                    :loading="loadingDays" :disabled="loadingDays || benef.month === null"
                                    item-text="name" label="Día" return-object required filled solo>
                                  </v-select>
                                </v-col>
                                <br v-if="screen < 800">
                                <v-col>
                                  <v-select class="labelDate" value="2022" :items="benef.years" v-model="benef.year"
                                    :rules="yearRules" item-text="name" label="Año" return-object required filled solo>
                                  </v-select>
                                </v-col>
                                <br v-if="screen < 800">
                              </v-row>

                            </v-col>
                          </v-card-text>
                          <br><br>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card>

                </template>

              </div>

              <br><br>

              <div v-if="screen < 800" style="width: 100%; display: flex;">
                <v-btn
                  style="background-color: #4F74E3 !important; color: white; display: flex; justify-content: center;"
                  @click="validate()" block>
                  Continuar
                </v-btn>
              </div>

              <br v-if="screen > 800">
              <br v-if="screen > 800">
              <br v-if="screen > 800">
              <br v-if="screen > 800">
              <br v-if="screen > 800">


              <div v-if="screen > 800" style="position: fixed; bottom: 0; left: 0; width: 100%; z-index: 9999;">
                <div class="cta-bar">
                  <div class="cta-item">
                    <div class="cta-content">
                      <img :src=ticketFooter alt="ticketFooter">
                      <div style="margin-left: 10px;">
                        <div class="cta-label">Tipo de plan:</div>
                        <div v-if="this.planData.plan.cantBenf.includes('familiar')" class="cta-value">Familiar</div>
                        <div v-else class="cta-value">Individual</div>
                      </div>
                    </div>
                  </div>

                  <div class="cta-item">
                    <div class="cta-content">
                      <img :src=watchFooter alt="watchFooter">
                      <div style="margin-left: 10px;">
                        <div class="cta-label">Activación:</div>
                        <div class="cta-value">En 30 días continuos</div>
                      </div>
                    </div>
                  </div>

                  <div class="cta-item">
                    <div class="cta-content">
                      <img :src=currencyFooter alt="currencyFooter">
                      <div style="margin-left: 10px;">
                        <div class="cta-label">Prima mensual:</div>
                        <div class="cta-value">{{ formatPrice(planData.plan.values[0].priceCLP) }} (UF {{
                          (planData.plan.values[0].price).toFixed(2) }})</div>
                      </div>
                    </div>
                  </div>

                  <div v-if="loadingNext == false" class="cta-item">
                    <v-btn :class="btnContinue" style="background-color: #4F74E3 !important; color: white !important;"
                      @click="validate()">
                      Continuar
                    </v-btn>
                  </div>

                  <div v-if="loadingNext == true" class="text-center" style="margin-right:17%; margin-left: 5%;">
                    <v-progress-circular :size="20" color="white" indeterminate></v-progress-circular>
                  </div>

                </div>
              </div>

            </v-form>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
import ShieldService from "../services/shield.service";
import dateService from "@/services/date.service.js";
import yearService from "@/services/year.service.js";

import RutUtils from "@/utils/rut.utils.js";

import Titulo from "../components/Titulo.vue";
import agelist from "@/services/age-list.service.js";
import hijoList from "@/services/hijo-list.service.js";

import swal from 'sweetalert';
import CryptoJS from 'crypto-js';

import infoImage from "@/assets/images/Ayuda.png";
import NavBar from "@/components/NavBar.vue";

import clockIconMobile from "@/assets/images/clockIcon.svg";
import shieldIconMobile from "@/assets/images/shieldIcon.svg";
import cashIconMobile from "@/assets/images/cashIcon.svg";

import ticketFooter from "@/assets/images/ticketFooter.svg";
import watchFooter from "@/assets/images/watchFooter.svg";
import currencyFooter from "@/assets/images/currencyFooter.svg";

import Vue from "vue";
import { VueReCaptcha } from 'vue-recaptcha-v3'
const moment = require('moment');
const { VUE_APP_RECAPTCHA3_SITE_KEY } = process.env;
Vue.use(VueReCaptcha, { siteKey: VUE_APP_RECAPTCHA3_SITE_KEY })

export default {
  name: "Step1",
  components: { Titulo, NavBar },
  data: () => ({
    activeTab: 'benef-0',
    text: 'Lorem ipsum ...',
    loadingDays: false,
    secretKey: process.env.VUE_APP_CRYPT,
    dialogFamiliar: false,
    firstPlanId: null,
    lengthBenef: null,
    clockIconMobile,
    shieldIconMobile,
    cashIconMobile,
    infoImage,
    ticketFooter,
    watchFooter,
    currencyFooter,
    loadingNext: false,
    summaryContainerBenef: null,
    formatter: new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
    }),
    loadPlans: false,
    stepperColor: '#4F74E3',
    e1: 2,
    Vstep: '',
    Vflex: '',
    personType: [
      "Hijo(a)",
      "Pareja",
      "Cónyuge",
    ],
    styleParentesco: null,
    styleEdad: null,
    info: [['Isapre Individual', 'Isapre Familiar', 'Fonasa Individual', 'Fonasa Familiar'], ['100%', '100%', '100%', '100%'], ['30.000', '30.000', '30.000', '30.000'], ['50', '50', '50', '50'], ['0', '24', '0', '24'], ['0', '50', '0', '50']],
    indexInfo: '0',
    plan: [],
    plansOutDesc: [],
    auxRelationship: '',
    auxRelationshipAge: '',
    userData: {
      name: null,
      surname: null,
      serialNumber: null,
      rut: null,
      typeIsapre: null,
      region: null,
      commune: null,
      comuneCode: null,
      regionCode: null,
      address: null,
      email: null,
      phoneNumber: null,
      couponId: null,
      stepId: null,
      old: null,
      dates: null,
      salud: null,
      questionOne: null,
      questionTwo: null,
      questionThree: null,
      typePlan: null,
      addressNumber: null,
      addressDepto: null,
      sonExist: false,
      arrayTypesBenef: [],
      oldAux: null,
      day: null,
      month: null,
      year: null,
    },
    servicesData: {
      stepId: null,
      contactID: null,
      type: 'create',
    },
    planData: {
      planOutDesc: null,
      setDesc: false,
      valueDesc: 0,
      couponId: null,
      plan: null,
    },
    benefData: [
      {
        tab: '',
        validRut: false,
        tipo: null,
        edad: null,
        name: '',
        surname: '',
        rut: '',
        days: ['Selecciona el mes'],
        months: null,
        years: null,
        date: null,
        newRut: '',
        panel: 0,
        year: null,
        month: null,
        day: null,
      }
    ],
    old: null,
    screen: window.screen.width,
    agelist: [],
    hijoList: [],
    valid: false,
    activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
    edadRules: [
      (v) => !!v || "La edad es requerida",
    ],
    parentescoRules: [
      (v) => !!v || "El parentesco es requerido",
    ],
    rutRules: [
      (v) => !!v || "El RUT es requerido",
      (v) => (v && v.length >= 11 && v.length <= 12) || "Rut no válido",
      (v) => RutUtils.validateRut(v) || "Rut no válido",
    ],
    nameRules: [
      // (v) => !!v || "El nombre es requerido",
      (v) => !!v.trim() || "El nombre es requerido",
      // (v) => !/^[0-9]*$/.test(v) || "Ingrese solo letras",
      (v) => /^[a-zA-ZáéíóúüÜñÑ\s]+$/.test(v) || "Ingrese solo letras",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 carácteres"
    ],
    surnameRules: [
      // (v) => !!v || "El apellido es requerido",
      (v) => !!v.trim() || "El apellido es requerido",
      (v) => /^[a-zA-ZáéíóúüÜñÑ\s-]+$/.test(v) || "Ingrese solo letras",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 carácteres"
    ],
    dayRules: [
      (v) => !!v || "La día es requerido",
    ],
    monthRules: [
      (v) => !!v || "El mes es requerido",
    ],
    yearRules: [
      (v) => !!v || "El año es requerido",
    ],
    newRut: "",

  }),
  async mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;

    const userDataAux = sessionStorage.getItem('userData');
    const servicesDataAux = sessionStorage.getItem('servicesData');
    const planDataAux = sessionStorage.getItem('planData');
    const benefDataAux = sessionStorage.getItem('benefData');

    const query = this.$route.query;

    if (query.stepID) {
      const abandoned = await ShieldService.newGetStepAbandoned(query.stepID);

      this.userData = abandoned.userData;
      this.servicesData.stepId = abandoned._id;
      this.servicesData.type = 'update';
      this.planData = abandoned.planData;
      this.benefData = abandoned.benefData;

      this.mayorEdad();

      const userDataLocal = JSON.stringify(this.userData);
      const servicesDataLocal = JSON.stringify(this.servicesData);
      const planDataLocal = JSON.stringify(this.planData);
      const benefDataLocal = JSON.stringify(this.benefData);

      const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
      const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
      const encryptedPlanDataLocal = CryptoJS.AES.encrypt(planDataLocal, this.secretKey).toString();
      const encryptedBenefDataLocal = CryptoJS.AES.encrypt(benefDataLocal, this.secretKey).toString();

      sessionStorage.setItem('userData', encryptedUserDataLocal);
      sessionStorage.setItem('servicesData', encryptedServicesDataLocal);
      sessionStorage.setItem('planData', encryptedPlanDataLocal);
      sessionStorage.setItem('benefData', encryptedBenefDataLocal);

    } else if (benefDataAux) {

      const bytesBenefData = CryptoJS.AES.decrypt(benefDataAux, this.secretKey);
      const decryptedDataBenef = bytesBenefData.toString(CryptoJS.enc.Utf8);
      this.benefData = JSON.parse(decryptedDataBenef);
      // console.log("benefData: ", this.benefData);

      const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
      const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(decryptedDataUser);
      // console.log("userData: ", this.userData);

      const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
      const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
      this.servicesData = JSON.parse(decryptedServicesData);
      // console.log("servicesData: ", this.servicesData);

      const bytesPlanData = CryptoJS.AES.decrypt(planDataAux, this.secretKey);
      const decryptedDataPlan = bytesPlanData.toString(CryptoJS.enc.Utf8);
      this.planData = JSON.parse(decryptedDataPlan);
      // console.log("planData: ", this.planData);

      this.mayorEdad();

    } else {
      const bytesBenefData = CryptoJS.AES.decrypt(benefDataAux, this.secretKey);
      const decryptedDataBenef = bytesBenefData.toString(CryptoJS.enc.Utf8);
      this.benefData = JSON.parse(decryptedDataBenef);
      // console.log("benefData: ", this.benefData);

      const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
      const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(decryptedDataUser);
      // console.log("userData: ", this.userData);

      const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
      const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
      this.servicesData = JSON.parse(decryptedServicesData);
      // console.log("servicesData: ", this.servicesData);

      const bytesPlanData = CryptoJS.AES.decrypt(planDataAux, this.secretKey);
      const decryptedDataPlan = bytesPlanData.toString(CryptoJS.enc.Utf8);
      this.planData = JSON.parse(decryptedDataPlan);
      // console.log("planData: ", this.planData);
    }

    if (this.screen > 800) {
      this.styleParentesco = 'labelParentesco'
      this.styleEdad = 'labelEdad'
      this.Vstep = 'VstepDesktop';
      this.Vflex = 'VflexDesktop';
      this.summaryContainerBenef = 'summaryContainerBenef'
    } else {
      this.styleParentesco = 'labelParentesco2'
      this.styleEdad = 'labelEdad2'
      this.Vflex = 'VflexMobile';
      this.summaryContainerBenef = 'summaryContainerBenef2'
    }

    this.getAgeList();
    this.getHijoList();
    this.setArrays();

  },
  methods: {
    async setArrays() {

      const monthsArray = await dateService.getMonths();
      const yearsArray = await yearService.getYears();

      this.benefData.forEach((benef, index) => {
        benef.months = monthsArray;
        benef.years = yearsArray;
        if (benef.date) {
          this.getDaysMounted(index);
        }
      });
    },
    async getDays(index) {

      if (this.benefData[index].month) {
        this.loadingDays = true;
        this.benefData[index].day = null;
        this.benefData[index].days = await dateService.getDays(this.benefData[index].month.name);
        this.changeBisiesto(index);
        this.loadingDays = false;
      }
    },
    async getDaysMounted(index) {
      if (this.benefData[index].month) {
        this.loadingDays = true;
        this.benefData[index].days = await dateService.getDays(this.benefData[index].month.name);
        this.changeBisiesto(index);
        this.loadingDays = false;
      }
    },
    async changeBisiesto(index) {
      if (this.benefData[index].month && this.benefData[index].year && this.benefData[index].days && this.benefData[index].month.name == 'Febrero' && !this.isBisiesto(this.benefData[index].year.id) && this.benefData[index].days.length == 29) {
        this.benefData[index].date = null;
        this.benefData[index].days = await dateService.getDays(
          this.benefData[index].month.name, false
        );
        this.daysArray = this.benefData[index].days
      } else if (this.benefData[index].month && this.benefData[index].year && this.benefData[index].days && this.benefData[index].month.name == 'Febrero' && this.isBisiesto(this.benefData[index].year.id) && this.benefData[index].days.length == 28) {
        this.benefData[index].days = await dateService.getDays(
          this.benefData[index].month.name, true
        );
        this.daysArray = this.benefData[index].days
      } else {
        this.benefData[index].days = await dateService.getDays(
          this.benefData[index].month.name, null
        );
        this.daysArray = this.benefData[index].days
      }
    },
    isBisiesto(anio) {
      return (anio % 4 === 0 && anio % 100 !== 0) || (anio % 400 === 0);
    },
    changeRut(index) {

      const cleanRut = RutUtils.cleanRut(this.benefData[index].newRut);
      const formattedRut = RutUtils.formatRut(this.benefData[index].newRut);

      const isRutDuplicated = this.benefData.some((beneficiary, idx) => {
        if (beneficiary.rut.trim() !== '' && this.benefData[index].newRut.trim() !== '') {
          return idx !== index && RutUtils.cleanRut(beneficiary.rut) === cleanRut;
        } else {
          return false;
        }
      });

      if (isRutDuplicated) {
        swal({
          title: "¡Atención!",
          text: "¡Tu RUT no puede coincidir con el de otro beneficiario!",
          icon: "info",
          button: "De acuerdo",
        });
      } else {
        this.benefData[index].rut = formattedRut;
        this.benefData[index].newRut = formattedRut;
      }

    },
    InfoFamiliar() {
      if (this.plan.name == 'Plan Familiar Isapre') {
        this.indexInfo = 1
        this.document = '/documents/ISAPRE_v2.pdf'
      }
      else if (this.plan.name == 'Plan Familiar Fonasa') {
        this.indexInfo = 3
        this.document = '/documents/FONASA_v2.pdf'
      }
      this.dialogFamiliar = true
    },
    async validate() {
      if (this.$refs.form.validate()) {

        await this.$recaptchaLoaded();
        const tokenStep = await this.$recaptcha('captchaToken');

        this.loadingNext = true

        const hoy = moment();

        const hayDiferencias = this.benefData.some(b => {
          const fecha = moment(
            `${b.year.id}-${String(b.month.number).padStart(2, '0')}-${String(b.day.id).padStart(2, '0')}`,
            'YYYY-MM-DD'
          );

          const edadReal = hoy.diff(fecha, 'years');
          return Number(b.edad) !== edadReal;
        });


        if (hayDiferencias) {
          this.loadingNext = false
          swal({
            title: "¡Atención!",
            text: "¡La fecha de nacimiento no concuerda con la edad de algun familiar!",
            icon: "info",
            button: "De acuerdo",
          });
        } else {

          this.userData.sonExist = this.benefData.some(benef => benef.tipo === "Hijo(a)");
          this.userData.arrayTypesBenef = this.benefData.map(item => item.tipo);

          const userDataLocal = JSON.stringify(this.userData);
          const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
          sessionStorage.setItem('userData', encryptedUserDataLocal);

          const benefDataLocal = JSON.stringify(this.benefData);
          const encryptedBenefDataLocal = CryptoJS.AES.encrypt(benefDataLocal, this.secretKey).toString();
          sessionStorage.setItem('benefData', encryptedBenefDataLocal);

          try {

            await ShieldService.newCreateStep(null, this.benefData, null, this.servicesData, 'Beneficiarios', tokenStep);

          } catch (error) {
            console.log("Cart Fail");
          }

          if (this.userData.email && this.activeCampaingUse == 'TRUE') {
            const activeCampaingRes = await ShieldService.getContactActiveCampain(this.userData.email);

            this.servicesData.contactID = activeCampaingRes.data.data.contacts[0].id;

            await ShieldService.updateContactActiveCampain(this.userData, this.planData, this.servicesData, 5);

            const servicesDataLocal = JSON.stringify(this.servicesData);
            const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
            sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

          }

          this.$router.push({ path: '/og/datos-contratante' });
        }
      }
    },
    async getAgeList() {
      this.loadingAgeList = true;
      this.agelist = await agelist.getAgeList();
      this.loadingAgeList = false;
    },
    async getHijoList() {
      this.loadingHijoList = true;
      this.hijoList = await hijoList.getHijoList();
      this.loadingHijoList = false;
    },
    async mayorEdad() {
      if (this.benefData.length != 0) {
        this.userData.typePlan = 'Familiar';

        const validBeneficiaries = this.benefData.filter(benef => benef.edad !== null);

        if (validBeneficiaries.length === 0) {
          this.userData.oldAux = this.userData.old.name;
        } else {
          const oldestBeneficiary = validBeneficiaries.reduce((oldest, current) => {
            return (current.edad.name > oldest.edad.name) ? current : oldest;
          }, validBeneficiaries[0]);

          if (this.benefData.length == 1) {
            this.userData.oldAux = oldestBeneficiary.edad.name;
          } else {
            this.userData.oldAux = this.userData.old.name < oldestBeneficiary.edad.name ? oldestBeneficiary.edad.name : this.userData.old.name;
          }

        }

      } else {
        this.userData.oldAux = this.userData.old.name;
        this.userData.typePlan = 'Individual';
      }

    },
    formatPrice(number) {
      return this.formatter.format(number);
    },
    back() {
      this.$router.push({ path: '/og/planes' })
    },
  },
};
</script>

<style lang="scss">
html body div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap main.v-main div.v-main__wrap div.container div.v-stepper.v-sheet.theme--light.elevation-0 div.v-stepper__items div.v-stepper__content div.v-stepper__wrapper div form.v-form div.formData div.row div.col div.circle-container button.circle-button i.v-icon.notranslate.mdi.mdi-minus.theme--light {
  font-size: 30px !important;
}

.summaryContainerBenef2 {
  background-color: #2D387C;
  position: absolute;
  z-index: 1;
  width: 100%;
  margin-left: 0%;
  height: auto;
  padding-top: 3%;
  padding-bottom: 3%;
  margin-bottom: -12% !important;
}

.VstepDesktop {
  margin-top: -0.3%
}

.VflexDesktop {
  background-color: rgb(247, 247, 247);
  display: flex;
  margin: auto;
  height: 50px;
}

.VflexMobile {
  background-color: rgb(247, 247, 247);
  display: flex;
  margin: auto;
  height: 30px;
  margin-top: -2.3%;
  margin-bottom: 2.3%
}

.headerSlider {
  color: white !important;
}

.labelInfo3 {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  color: #232323;
  opacity: 0.75;
  margin: auto;
}

.labelPlanes {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
  padding: 1%;
  margin-bottom: 3%;
}

.labelSubPlanes {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  margin-top: -3%;
}

.labelSubPlanes2 {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  padding-bottom: 5%;
}

.labelParentesco {
  width: 257px;
  height: 57px;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
}

.labelParentesco2 {
  width: 130px;
  height: 57px;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
}

.labelEliminar {
  color: white;
  box-sizing: border-box;
  width: 35px;
  height: 35.1px;
  border: 0.5px solid #4F74E3;
  margin-top: 15%
}

.labelEdad {
  width: 94px;
  height: 57px;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
}

.labelEdad2 {
  width: 80px;
  height: 57px;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
}

.botonAgregar {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.02em;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: auto;
}

.step-date {
  max-width: 200px;
  align-items: center;
  display: flex;
  margin-left: 2rem;
  justify-content: center;

  .v-select {
    max-width: 400px;
  }
}

.form-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 800px;
}

.infoIcon {
  background-image: url("~@/assets/images/Ayuda.png");
}

.labelResumen {
  box-sizing: border-box;
  width: 100%;
  max-width: 350px;
  height: 114px;
  background: linear-gradient(90deg, #2D387C 3.42%, #4F74E3 97.26%);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  margin: auto;
}

.labelNamePlan {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  text-align: center;
  color: #FFFFFF;
}

.labelPrecio {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 36px;
  text-align: center;
  letter-spacing: -0.01em;
  color: #FFFFFF;
}

.labelSubDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  color: #FFFFFF;
}

.labelSubPrecio {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: rgba(255, 255, 255, 0.87);
}

.formData {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.v-messages__message {
  padding-bottom: 10%;
  text-align: left !important;
  min-width: 100px;
}




@media only screen and (max-width: 959.98px) {

  // Evita el mecanismo de esconder las letras del steper
  .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: block !important;
    font-size: 12px !important;
  }
}

.circle-step {
  font-size: 14px;
  width: 10%;
}

.v-stepper__step__step {
  // Este es el step y sus medidas
  height: 40px !important;
  width: 40px !important;
  font-size: 20px !important;
  margin-top: 30%;
  background-size: cover;
  display: none !important;
}

@media only screen and (max-width: 767px) {
  .v-stepper__step__step {
    width: 42px !important;
    height: 42px !important;
    font-size: 20px !important;
    margin-top: 40%;
  }
}

@media only screen and (max-width: 767px) {
  .circle-step {
    margin-top: -1%;
  }

  .circle-step2 {
    margin-top: -1%;
  }
}

.v-stepper__header {
  // Stepper header - contenedor de steper completo
  box-shadow: none !important;
  align-items: initial !important;
  margin: auto !important;
  flex-wrap: nowrap !important;
  width: 32% !important;
  height: 45px;
}

.v-stepper__label {
  padding: 10%;
  margin-top: 10px;
}

@media only screen and (max-width: 767px) {
  .v-stepper__header {
    // Stepper header - contenedor de steper completo
    box-shadow: none !important;
    max-width: 100%;
    align-items: center;
    margin: auto;
    width: 70% !important;
    font-size: 12px !important;
    height: 32px;
  }
}

.v-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: auto;
  border: none !important;
  /* Elimina la línea */
  margin: 0 10px;
  /* Espacio entre pasos */
}

.v-divider::before {
  content: '\003E' !important;
  /* Código de la flecha '>' */
  font-size: 24px !important;
  /* Tamaño del icono */
  color: #5C6670 !important;
  /* Color de la flecha */
  font-weight: 300 !important;
}

@media only screen and (max-width: 767px) {
  .v-divider::before {
    content: '\003E' !important;
    /* Código de la flecha '>' */
    font-size: 18px !important;
    /* Tamaño del icono */
    color: #5C6670 !important;
    /* Color de la flecha */
    font-weight: 300 !important;
    // height: 20px !important;
  }
}

.theme--light.v-stepper .v-stepper__step--active .v-stepper__label {
  text-shadow: 0px 0px 0px #4F74E3 !important;
}

.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
  color: #2183f3 !important;
}

.v-stepper__step {
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: 0px !important;
  position: relative;
}

@media only screen and (max-width: 767px) {
  .v-stepper__step {
    align-items: center;
    display: flex;
    flex-direction: row;
    padding: 20px; // el ancho
    position: relative;
  }
}

@media only screen and (max-width: 767px) {
  .step-data {
    display: inline !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.v-stepperstep {
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: 30px; // el ancho
  position: relative;
}

.v-stepperheader .v-divider {
  margin: 0 -30px;
}


@media only screen and (max-width: 767px) {
  .v-stepper__header .v-divider {
    margin: 0 -15px;
  }
}

.vSteperStyle {
  max-width: 40%;
  margin: auto;
}

.vSteperStyle2 {
  margin: auto;
}

.v-tooltip__content {
  background: none;
}

.v-tooltip__content.menuable__content__active {
  opacity: 1 !important;
}

s .encabezado {
  color: #2D387C;
  font-size: 18px;
  font-weight: 600;
}

.texto {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: rgba(0, 0, 0, 0.5);
  flex: none;
  order: 1;
  flex-grow: 0;
}

.textoAzul {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400px;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #2D387C;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.labelDate {
  max-width: 100%;
  height: 57px;
  background: #ffffff;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
}

.labelEtiqueta {
  font-family: Poppins;
  font-style: normal;
  width: 147px;
  height: 25px;
  font-weight: 400;
  font-size: 15px;
  line-height: 25px;
  color: #5a5a5a;
  letter-spacing: -0.01em;
}

.btnContinue {
  background-color: #4F74E3 !important;
  color: white !important;
  border-radius: 12px;
  width: 300px;
}

.cta-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  background: #2a3a86;
  color: #fff;
  border-radius: 6px;
}

.cta-item {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
}

.cta-content {
  display: flex;
  align-items: center;
}

.cta-label {
  font-size: 12px;
  line-height: 1;
  opacity: 0.85;
}

.cta-value {
  font-size: 12px;
}
</style>